import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Zap, Utensils } from "lucide-react";
import { Badge } from "./ui/badge";

const SOURCE_LABEL = {
    meat_trade: { label: "Meat Trade Survivor", cls: "bg-[#4a1a1a] text-white hover:bg-[#4a1a1a]" },
    street: { label: "Street Rescue", cls: "bg-[var(--rl-sage)] text-[var(--rl-text)] hover:bg-[var(--rl-sage)]" },
    puppy_mill: { label: "Puppy Mill Survivor", cls: "bg-[#3a2f52] text-white hover:bg-[#3a2f52]" },
    surrender: { label: "Owner Surrender", cls: "bg-[var(--rl-cream)] text-[var(--rl-text-2)] hover:bg-[var(--rl-cream)]" },
    shelter_overflow: { label: "Shelter Overflow", cls: "bg-[var(--rl-cream)] text-[var(--rl-text-2)] hover:bg-[var(--rl-cream)]" },
    abuse: { label: "Abuse Survivor", cls: "bg-[#4a1a1a] text-white hover:bg-[#4a1a1a]" },
};

export default function DogCard({ dog, urgent = false }) {
    const cls = urgent ? "card-urgent" : "card-warm";
    const source = dog.rescue_source ? SOURCE_LABEL[dog.rescue_source] : null;
    return (
        <Link
            to={`/dogs/${dog.id}`}
            data-testid={`dog-card-${dog.id}`}
            className={`${cls} rounded-lg overflow-hidden block group`}
        >
            <div className="aspect-[4/3] overflow-hidden bg-[var(--rl-cream)] relative">
                <img
                    src={dog.photo_url}
                    alt={dog.name}
                    className="w-full h-full object-cover group-hover:scale-[1.03]"
                    style={{ transition: "transform 500ms ease" }}
                    loading="lazy"
                />
                {urgent && (
                    <div className="absolute top-3 left-3 bg-[var(--rl-urgent)] text-white text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full font-semibold flex items-center gap-1.5 urgent-pulse">
                        <Zap className="w-3 h-3" fill="white" strokeWidth={0} /> At Risk
                    </div>
                )}
                {dog.rescue_source === "meat_trade" && (
                    <div className="absolute top-3 right-3 bg-[#4a1a1a] text-white text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full font-semibold flex items-center gap-1.5" data-testid="meat-trade-badge">
                        <Utensils className="w-3 h-3" /> Meat Trade
                    </div>
                )}
            </div>
            <div className="p-4">
                <div className="flex items-baseline justify-between gap-2">
                    <h3 className="font-serif text-xl leading-tight">{dog.name}</h3>
                    <span className="text-xs text-[var(--rl-text-3)] whitespace-nowrap">{dog.age}</span>
                </div>
                <div className="text-[13px] text-[var(--rl-text-2)] mt-0.5">{dog.breed}</div>
                <div className="flex items-center gap-1 text-xs text-[var(--rl-text-3)] mt-2">
                    <MapPin className="w-3 h-3" /> {dog.location}
                </div>
                <div className="flex flex-wrap gap-1.5 mt-3">
                    <Badge variant="outline" className="text-[10px] uppercase tracking-widest bg-[var(--rl-cream)] border-[var(--rl-border)]">{dog.size}</Badge>
                    <Badge variant="outline" className="text-[10px] uppercase tracking-widest bg-[var(--rl-cream)] border-[var(--rl-border)]">{dog.energy_level} energy</Badge>
                    {dog.region && dog.region !== "North America" && (
                        <Badge className="text-[10px] uppercase tracking-widest bg-[var(--rl-primary)] text-white hover:bg-[var(--rl-primary)]">{dog.region}</Badge>
                    )}
                    {source && dog.rescue_source !== "meat_trade" && (
                        <Badge className={`text-[10px] uppercase tracking-widest ${source.cls}`}>{source.label}</Badge>
                    )}
                </div>
            </div>
        </Link>
    );
}
